module.exports = __webpack_public_path__ + "static/media/conway.89c10e5a.gif";